import { IAccountsDataManager, IPostAddressBookEntriesParams, IUpdateAccountMetaInfoParams } from './iaccounts_data_managter';
import { IClientConfig } from '../data_manager/data_manager_factory';
import { AjaxHelper } from '../../http/ajax_helper';
import { IAjaxHelperConfig } from '../../http/iajax_helper_config';

export class UAAccountsManager implements IAccountsDataManager   {
    discoveryEndPoints: {accountsService: string; };
    constructor(config: IClientConfig) {
        this.discoveryEndPoints = config.discoveryEndPoints;
    }    

    postAddressBookEntries(params: IPostAddressBookEntriesParams){
      const url = '/v1/account/' + params.accountId + '/address';
      const config = {
        url: this.discoveryEndPoints.accountsService + url,
        type: "POST",
        data: params.data,
        ignoreAToken:true
      }
      const promise = AjaxHelper.triggerApi({ requestConfig: config });
        
      return promise;
    }

    getAddressBookEntries(accountId: string): Promise<any> {
      const url = '/v1/account/' + accountId + '/address?queryLimit=2000';
      const config = {
        url: this.discoveryEndPoints.accountsService + url,
        type: "GET",
        ignoreAToken:true,
        ignoreResCaching: true
      }
      const promise = AjaxHelper.triggerApi({ requestConfig: config })
    
      return promise;
    }
    updateAccountMetaInfo(params: IUpdateAccountMetaInfoParams): Promise<any> {
        const url = '/v1/account/' + params.accountId + '/globalInfo';
        const config = {
            url: this.discoveryEndPoints.accountsService + url,
            type: "PUT",
            data: JSON.stringify(params.data),
            ignoreAToken:true
        }
        const promise = AjaxHelper.triggerApi({ requestConfig: config });
        
        return promise;
    }    
}